//require jQuery
var $ = require('jquery');
window.jQuery = window.$ = $;

//require modules
require('slick-carousel');
require('jquery-sticky-kit');
require('sidr/dist/jquery.sidr.js');

// Jquery here
$(document).ready(function(){
	
	//sidr menu
	$('a.mobile-nav').sidr({
		source: 'nav .menu',
		side: 'right'
	});
	$("body").on("click touchstart",function(e) {
    $.sidr('close','sidr');
  });
  $("#sidr").on("click touchstart",function(e) {
    e.stopPropagation();
	});
	
	//set height of slider to screen height
	//$('#hp-fold').css('height',$(window).height()-$('header').height());
	
	//HP-Slider
  if($('.slick-fold').length>0){
    $('.slick-fold').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 500,
      arrows:false,
      dots:true,
      autoplay: true,
      autoplaySpeed: 6000,
      fade: true,
      cssEase: 'linear',
      pauseOnHover: false
    });
	}
	
	if($('.slick-charter').length>0){
    $('.slick-charter').slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      speed: 400,
      arrows:true,
      dots:false,
      autoplay: true,
      autoplaySpeed: 6000,
      cssEase: 'ease-in-out',
      pauseOnHover: false
    });
	}
	
	$('.collapsed li').on('click',function(e){
	  if($(this).hasClass('open')) {
		  $(this).removeClass('open');
	  } else {
	  	$(this).addClass('open');
	  }
	});
	
	//Sticky Nav
	//$("nav.nav").stick_in_parent({parent:'body'});
	
	
	//CONTACT FORM - special labels utility function
	if($('.contact-form').length>0){
		var checkForInput = function(){
			$('.contact-field:not(.select-field)').each( function(i,e){
	    	if($(this).children().last().val().length>0){
		    	$(this).addClass('float-label');
	    	}else{
		    	$(this).removeClass('float-label');
	    	}
			});
		}
		
		checkForInput();
		
		//trigger label function on change
		$('.contact-field textarea, .contact-field input').on('keyup',checkForInput);
		
	}
	
	//Contact Form Processing Creation
var formFactory = function(formSelector, formName, hasAttachments, validateArray){
	
	$(formSelector).on('click', 'input[type="submit"]',function(e){
    e.preventDefault();
    var $form = $(formSelector);
    
    var themeName = 'sailobx';
    var errorEmail = 'zach.i@rollwithduckpin.com';
    console.log('form working');
    
    //clear out errors
    var errors= 0;
    $('input,textarea').removeClass('invalid');
    
    for (var i = 0, len = validateArray.length; i < len; i++) {
			if($(validateArray[i].inputType + '[name="' + validateArray[i].inputName + '"]').val()==''){
      	errors++;
    	}
		}
		
    var $captcha = $( '#recaptcha' ),
      response = grecaptcha.getResponse();
      console.log(response);
  
	  if (response == '') {
	    if( !$captcha.hasClass( "error" ) ){
	      $captcha.addClass( "error" );
	    }
	    errors++;
	  } else {
	    $( '.general-error' ).text('');
	    $captcha.removeClass( "error" );
	  }
    
    if(errors==0){
	    if(!hasAttachments){
      
	      var data = $form.serialize();
	      $.ajax({
	        method: "POST",
	        url: "/wp-content/themes/" + themeName + "/processors/process-contact.php",
	        data: data,
	      }).done(function(msg){
	        if(msg=="empty"){
	          $('.general-error').html('Please fill the required fields.').fadeIn('slow');
	          //ga('send', 'event', formName + ' Page', 'Unsuccessful Form Send', formName + ' Form');
	        }else if(msg=="sendfail"){
	          $('.general-error').html('Error sending message. Please send an email to ' + errorEmail + '').fadeIn('slow');
	          //ga('send', 'event', formName + ' Page', 'Unsuccessful Form Send', formName + ' Form');
	        }else{
		        	//ga('send', 'event', formName + ' Page', 'Successful Form Send', formName + ' Form');
	            $form.fadeOut('slow',function(){
		          $('.general-error').fadeOut('slow');  
	            $('.success-msg').fadeIn('slow');
	          });
	        }
	      }).fail(function(msg){
	        $('.general-error').html('Oops! Something has gone wrong. Please send an email to ' + errorEmail + '').fadeIn('slow');
	        //ga('send', 'event', formName + ' Page', 'Unsuccessful Form Send', formName + ' Form');
	      });
    	
    	} else {
	    	//ga('send', 'event', formName + ' Page', 'Successful Form Send', formName + ' Form');
	    	$(formSelector).submit();
	    	console.log('form submitted');
    	}
    	
    } else {
      $('.general-error').html('Please fill the required fields.').fadeIn('slow');
      //ga('send', 'event', formName + ' Page', 'Unsuccessful Form Send', formName + ' Form');
    }
    
  });
	
}

//DECLARE FUNCTIONS AS NECESSARY
formFactory('form.contact-form', 'Contact Us', false, [{inputName:'name', inputType:'input'},{inputName:'email', inputType:'input'}]);
//formFactory('form.careers-form', 'Career Application', true, [{inputName:'name', inputType:'input'},{inputName:'email', inputType:'input'}]);


//WP REST API STUFF (MAKE SURE TO UNCOMMENT VUE.JS IN SCRIPTS)
var UsingRestAPI = false;

if(UsingRestAPI){
  var getUrl = window.location;
	var baseUrl = getUrl.protocol + "//" + getUrl.host;
  var apiURL = baseUrl + 'wp-json/wp/v2/posts';
  
	var posts = new Vue({
	
		el: '#your-app',
	
		data: {
			posts: null,
			totalPages: null,
			currentPage: 1
		},
	
		created: function() {
			this.fetchData();
		},
	
		watch: {
			
		},
	
		methods: {
			fetchData: function() {
				var xhr = new XMLHttpRequest();
				var self = this;
				xhr.open('GET', apiURL + self.currentPage);
				xhr.onload = function() {
					self.totalPages = xhr.getResponseHeader('x-wp-totalpages');
					self.posts = JSON.parse(xhr.responseText);
					//console.log(self.totalPages);
					
					if(self.currentPage >= self.totalPages){$('.your-app-next').addClass('hide');}
					if(self.currentPage < self.totalPages){$('.your-app-next').removeClass('hide');}
					if(self.currentPage == 1){$('.your-app-prev').addClass('hide');}
					if(self.currentPage > 1){$('.your-app-prev').removeClass('hide');}
					
				};
				xhr.send();
			},
			updatePage: function(direction){
				if(direction == 'next'){this.currentPage += 1}else if(direction == 'prev'){this.currentPage -= 1};
				this.fetchData();
			}
		}
	});
}
	
$('.search-link, .search-close, .search-bg').on('click',function(e){
	e.preventDefault();

  if($('.search-takeover').hasClass('open')) {
	  $('.search-takeover').removeClass('open');
  } else {
  	$('.search-takeover').addClass('open');
  }
});

	// Contact form get URL Param
	var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
	};
	
	var inquiry = getUrlParameter('inquiry');
	
	if (inquiry == 'school') {
		
		$('.contact-form textarea').val('Please send me more info on SailOBX\'s Sailing School.').parent().addClass('float-label');
		$('.contact-form .subject').val('Booking Inquiry').parent().addClass('float-label');
		$('.contact-form .name').focus();
		
	} else if (inquiry) {
		
		$('.contact-form textarea').val('Please send me more info on booking a ' + inquiry.replace(/\+/g, ' ') + '.').parent().addClass('float-label');
		$('.contact-form .subject').val('Booking Inquiry').parent().addClass('float-label');
		$('.contact-form .name').focus();
		
	} else {}
	

// Scroll all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length - 95 ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top-95
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
					
        });
      }
    }
  });
	    	
});